import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NewContractPymesService } from 'src/app/services/new-contract-pymes.service';
import { UtilService } from 'src/app/services/util.service';
import { ToastrService } from '../ui/toastr/toastr.service';

@Component({
  selector: 'app-header-contract',
  templateUrl: './header-contract.component.html'
})

export class HeaderContractComponent implements OnInit {
  @Output() openResume = new EventEmitter<number>();
  @Output() saveDraft = new EventEmitter<number>();
  @Output() goNext = new EventEmitter<void>();
  @Output() goToStepper = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  @Output() cancelContract = new EventEmitter<boolean>();
  @Input() activeNext;
  @Input() activeNextCRM = false;
  @Input() hasContactoCRM;
  @Input() showProgress = true;
  @Input() noTypeSelected = true;

  public haveIdDraft: boolean;
  public progress = 0;
  public tabIndex: number;
  destroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private newContractService: NewContractPymesService,
    private toastrService: ToastrService,
    private utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.newContractService.getIndexContract().subscribe(
      value => {
        this.tabIndex = value;
        this.updateProgress();
      },
      error => {
        this.utilService.toastErrors(error);
      }
    );
    this.subscribeIdDraft();
  }

  private subscribeIdDraft(): void {
    this.newContractService.getSavedData().subscribe(res => {
      this.haveIdDraft = !!res?.idBorrador;
    });
  }

  cancel = () => {
    this.close.emit();
  }

  next = () => {
    this.goNext.emit();
  }

  goToContract = () => {
    this.goToStepper.emit();
  }

  updateProgress() {
    this.progress = +this.tabIndex * 25;
  }

  openDialog(event) {
    if (this.tabIndex !== 0) {
      this.openResume.emit(this.tabIndex);
    }
  }

  clickSave() {
    this.saveDraft.emit(+this.tabIndex + 1);
  }

  clickDownload() {
    this.toastrService.error('COMMONS.DOWNLOADING');
    this.newContractService
      .getContractTemplate()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (resultBlob: Blob) => {
          if (resultBlob.type !== 'application/json') {
            const downloadURL = URL.createObjectURL(resultBlob);
            window.open(downloadURL);
          } else {
            const reader = new FileReader();
            reader.addEventListener('loadend', e => {
              this.toastrService.error(JSON.parse(e.target.result as string).Message);
            });
            reader.readAsText(resultBlob);
          }
        },
        error => {
          this.utilService.toastErrors(error);
        }
      );
  }

  public deleteContract(): void {
    if (this.newContractService.getSavedData().value.idBorrador) {
      this.cancelContract.emit(true);
    } else if (this.newContractService.getSavedData().value.codigoContrato) {
      this.cancelContract.emit(false);
    }
  }
}
